/**
 * LangGraph Backend Configuration
 * Centralized configuration for LangGraph backend URLs.
 * Uses brand config for domain-agnostic production URLs (baiglabs / interviewflow.studio).
 */

import { getLangGraphBaseUrl } from '../config/brand.js';

export const getLangGraphBackendUrl = () => getLangGraphBaseUrl();

export const getLangGraphWsUrl = (path) => `${getLangGraphBaseUrl().replace(/^http/, 'ws')}${path}`;

export const getLangGraphHealthUrl = () => `${getLangGraphBackendUrl()}/health`;

export const getLangGraphExecuteFlowUrl = () => `${getLangGraphBackendUrl()}/execute-flow`;

export const getLangGraphFlowStatusUrl = (executionId) => `${getLangGraphBackendUrl()}/api/v1/flows/status/${executionId}`;

export const getLangGraphSubmitFormUrl = (executionId) => `${getLangGraphBackendUrl()}/api/v1/flows/submit-form/${executionId}`;

export const getLangGraphCleanupUrl = () => `${getLangGraphBackendUrl()}/executions/cleanup`;

export const getLangGraphRagUrl = () => `${getLangGraphBackendUrl()}/rag`;

export const getLangGraphModelsUrl = () => `${getLangGraphBackendUrl()}/models`;
